import React from 'react';
import { Clock } from 'lucide-react';

interface MissionHeaderProps {
  title: string;
}

const MissionHeader: React.FC<MissionHeaderProps> = ({ title }) => {
  const getTimeUntilDeadline = () => {
    const deadline = new Date('2025-12-31T23:59:59');
    const now = new Date();
    const diff = deadline.getTime() - now.getTime();
    
    if (diff <= 0) return 'Encerrada';
    
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    return `${days} ${days === 1 ? 'dia restante' : 'dias restantes'}`;
  };

  return (
    <div className="mb-6">
      <div className="inline-block px-3 py-1 bg-white/10 border border-white/20 rounded-full mb-2">
        <span className="text-xs font-medium text-white/80 tracking-wider">
          LANÇAMENTO OFICIAL
        </span>
      </div>
      
      <h1 className="text-lg font-semibold text-white mb-2">
        {title}
      </h1>
      
      <div className="flex items-center gap-1.5 text-white/60">
        <Clock className="w-3.5 h-3.5" />
        <span className="text-xs font-medium uppercase tracking-wide">
          {getTimeUntilDeadline()}
        </span>
      </div>
    </div>
  );
};

export default MissionHeader;
